import ExhibitorBookingForm from "@feature/pages/ExhibitorBookingForm";
import { Email } from "@mui/icons-material";

export const featurePaths = {
    TrafficJobList: "/trfcjoblist",
    UpdateTrafficJob: "/trfcjoblist/edittrafficjob",
    QuestionnaireForm: "/questionnaireform",
    TrafficScheduleManifest: "/bookedslotsdetails",
    UpdateVehicleBookingSummary: "/bookedslotsdetails/updateslotdetails",
    BookingPrint: "/bookedslotsdetails/bookingprint",
    ExhibitorBookingForm: "/exhibitorbookingform",
    TrafficEmailTemplateList: "/traffic/trafficemailtemplatelist",
    UpdateTrafficEmailTemplate: "/traffic/trafficemailtemplatelist/edittrafficemailtemplate",
     ViewQuestionnaireAnswers   : "/trfcjoblist/viewquestionnaireanswers",
    // UpdatePreAlert:"/trfcjoblist/editjob/updateprealertdata",
    // ReturnSenderInstruction:"/trfcjoblist/editjob/returnsenderinstruction"
} as const;

export const apiPaths = {} as const;
